

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-9 col-xl-9 col-md-12 col-xs-12 col-sm-12 col-12">    
            <div class="card" id="c_plannedoutagesdetail" style="margin-top: 5rem;">
                <div class="card-body">
                        <zsd-planned-outagesdetail></zsd-planned-outagesdetail>
                </div>
            </div>
        </div>    
        <div class="col-lg-3 col-xl-3 d-none d-lg-block d-xl-block">    
                <div class="card" id="c_relatedplannedoutagesrequests" style="margin-top: 5rem;">
                    <div class="card-body"  id="c_related_plannedoutages_requests_card">
                        <zsd-relatedplannedoutages></zsd-relatedplannedoutages>
                    </div>
                </div>
            </div>    
    </div>
</div>
